<template>
  <div class="main-container p-3">
    <KidHeader :profileId="profileId" :serialNumber="serialNumber" />

    <div class="back-home text-left mb-3">
      <a class="text-black" href="javascript:void(0)" @click="$router.push({ path: '/kids-device', query: { profileId: this.profileId, serialNumber: serialNumber } })">
        <i class="fas fa-arrow-left"></i> <b>Back to Home</b>
      </a>
    </div>

    <div class="text-right mt-4 pb-2" :style="{ 'width': '90%' }">
        <button
        class="btn btn-secondary px-4"
        :disabled="isDisabled"
        @click="sendFcmCommand()"
        >
        Fetch Location Now
        <span v-if="isDisabled"><i class="fa fa-spinner fa-spin ml-2"></i></span>
        </button>
    </div>
    <!-- Configure Location Tracking -->
    <div class="card shadow-sm mb-4">
      <div class="card-body">
        <h5 class="card-title text-black">
          Configure Location Tracking
        </h5><hr>
        
        Enable Location Tracking: 
        <label class="switch">
            <input type="checkbox" v-model="enableLocationTracking" @change="toggleLocationSetting()" >
            <span class="slider round"></span>
        </label>
        <div class="d-flex align-items-center justify-content-center gap-2 mt-3">
          <button class="btn btn-light border" @click="decreaseLimit()" :disabled="enableLocationTracking == false">
            <ArrowLeftIcon />
          </button>
          <input
            type="text"
            class="form-control text-center font-weight-bold"
            v-model="locationTrackingInterval"
            @blur="roundOF15()"
            style="max-width: 80px;"
            :disabled="enableLocationTracking == false"
          />
          <button class="btn btn-light border" @click="increaseLimit()" :disabled="enableLocationTracking == false">
            <ArrowRightIcon />
          </button>
        </div>

        <small class="text-muted d-block mt-3">
          <b>Location Tracking Interval: </b> Set the time interval (in minutes) at which you want your child’s device location to be automatically updated and tracked. A shorter interval provides more frequent updates, while a longer interval may help conserve battery life.
        </small>

        <div class="text-center mt-4">
          <button
            class="btn btn-primary px-4"
            :disabled="isDisabled"
            @click="updateLocationSetting()"
          >
            Save
            <span v-if="isDisabled"><i class="fa fa-spinner fa-spin ml-2"></i></span>
          </button>
        </div>
      </div>
    </div>
    <KidFooter :profileId="profileId" :serialNumber="serialNumber" />
  </div>
</template>

<script>
import KidHeader from '@/components/KidHeader.vue'
import KidFooter from '@/components/KidFooter.vue'
import KidsService from "../../services/KidsService";
import ProfileService from "../../services/ProfileService";
import ArrowLeftIcon from '@/components/icons/ArrowLeftIcon.vue'
import ArrowRightIcon from '@/components/icons/ArrowRightIcon.vue'

export default {
  name: 'Change Password',
  components: {
    KidHeader,
    KidFooter,
    ArrowLeftIcon,
    ArrowRightIcon
  },
  data() {
    return {
        profileId: this.$route.query.profileId,
        serialNumber: this.$route.query.serialNumber,
        isDisabled: false,
        enableLocationTracking: true,
        locationTrackingInterval: 0,
        deviceId: null,
    }
  },
  methods: {
    
    async getLocationSetting() {
        let data = {
            profile_id: this.profileId,
            serialNumber: this.serialNumber
        };
        await KidsService.getLocationSetting(data)
        .then((response) => {
            this.enableLocationTracking = response.data.data?.enableLocationTracking ?? true
            this.locationTrackingInterval = response.data.data?.locationTrackingInterval ?? 15
            this.deviceId = response.data.data?._id
            this.$toast.success(response.data.respones_msg);
        }).catch((e) => {
            this.isDisabled = false;
            this.$toast.error(e.response.data.respones_msg);
        });
    },
    updateLocationSetting() {
        this.isDisabled = true;
        let data = {
            _id: this.deviceId,
            enableLocationTracking: this.enableLocationTracking,
            locationTrackingInterval: this.locationTrackingInterval
        };
        KidsService.updateDevice(data)
        .then((response) => {
            this.isDisabled = false;
            this.$toast.success(response.data.respones_msg);
        }).catch((e) => {
            this.isDisabled = false;
            this.$toast.error(e.response.data.respones_msg);
        });
    },
    async sendFcmCommand() {
        this.isDisabled = true;
        let data = {
            title: "Send Location",
            message: "Send kid location",
            packageName: "",
            action: "send_location",
            serialNumber: this.serialNumber
        }
        await KidsService.sendFcmCommand(data)
        .then((response) => {
          this.isDisabled = false;
          this.$toast.success(response.data.respones_msg);
        }).catch((e) => {
          this.$toast.error(e.response.data.respones_msg);
          this.isDisabled = false;
        });
    },
    roundOF15() {
        if (this.locationTrackingInterval > 0) {
            this.locationTrackingInterval = Math.ceil(this.locationTrackingInterval/15.0) * 15;
        }
    },
    decreaseLimit() {
        if (this.locationTrackingInterval > 0) {
            this.locationTrackingInterval = this.locationTrackingInterval - 15
        }
    },
    increaseLimit() {
        if (!this.locationTrackingInterval) {
          this.locationTrackingInterval = 0;
        }
        this.locationTrackingInterval = (parseInt(this.locationTrackingInterval) + 15)
    },
    toggleLocationSetting() {
        if (this.enableLocationTracking == false) {
            this.locationTrackingInterval = 0
        }
    }
  },
  beforeMount() {
    this.getLocationSetting();
  },
}
</script>
<style scoped>
.card {
  border-radius: 10px;
}
input[type="text"] {
  font-size: 1.1rem;
}
.btn-icon-flex {
  display: flex;
  align-items: center;
  justify-content: center;
}

.btn-icon-flex i {
  margin-right: 8px;
}

.back-home {
  display: block;         /* Make it block level */
  width: 100%;            /* Full width */
  margin-bottom: 15px;
  font-size: 1rem;
}
</style>